<template>
  <div class="sc-header rounded-top relative flex items-center p-4 h-16"
       :style="styles.wrapper"
  >
    <img v-if="themeConfig.header.logoOnly && headerLogoSrc"
         :src="headerLogoSrc"
         alt="company logo"
         height="38"
    />

    <img v-else-if="headerLogoSrc"
         :src="headerLogoSrc"
         class="rounded-full mr-2"
         height="38"
         width="38"
         alt="company logo rounded"
    />

    <span v-if="!themeConfig.header.logoOnly"
          :style="styles.title"
    >
      {{ langConfigDefaultWelcome }}
    </span>

    <div class="ml-auto flex items-center self-center">
      <div v-if="showModalViewButton"
           class="sc-header--modal-view-button flex items-center justify-center rounded cursor-pointer mr-1"
      >
        <IconModalView :style="styles.closeBtn"/>
      </div>

      <div v-if="showWideViewButton"
           class="sc-header--wide-view-button flex items-center justify-center rounded cursor-pointer mr-1.5"
      >
        <IconWideView :style="styles.closeBtn"/>
      </div>

      <div class="sc-header--close-button flex items-center justify-center rounded cursor-pointer">
        <arrowDownIcon :style="styles.closeBtn"/>
      </div>
    </div>
  </div>
</template>

<script>
import arrowDownIcon from '@/assets/images/icons/chat-widget/arrowDownIcon.vue'
import IconModalView from '@/assets/images/icons/chat-widget/IconModalView.vue'
import IconWideView from '@/assets/images/icons/chat-widget/IconWideView.vue'

export default {
  name: 'ChatHeader',

  components: {
    arrowDownIcon,
    IconModalView,
    IconWideView
  },

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    langConfig: {
      type: Object,
      required: true
    },
    headerLogoCache: {
      type: File
    }
  },

  computed: {
    headerLogoSrc() {
      const logo = this.headerLogoCache || this.themeConfig.header.logoUrl
      if (!logo) return null

      if (logo instanceof File) {
        return URL.createObjectURL(logo)
      }

      return logo
    },

    styles() {
      return {
        wrapper: {
          background: this.themeConfig.header.bg,
          color: this.themeConfig.header.text,
          fontFamily: this.themeConfig.font
        },
        title: {
          padding: this.themeConfig.header.padding,
          fontSize: this.themeConfig.header.fontSize
        },
        closeBtn: {
          color: this.themeConfig.header.closeBtn.color
        }
      }
    },

    langConfigDefaultWelcome() {
      return this.langConfig?.default?.welcome
    },

    showWideViewButton() {
      return this.themeConfig.header?.showWideViewButton === true
    },

    showModalViewButton() {
      return this.themeConfig.header?.showModalViewButton === true
    }
  }
}
</script>
